// WHY AN ANYTIME FITNESS BOOKING NEEDED A PERSON, in words staff (and a club) can act on. ONE source: the booking service's
// cause type, the staff alert, the booth feed, the lead and conversation views all read this, so a cause can never appear as
// a generic "question for the team" (2026-11-04: it did, on the booth dashboard).
// ⚠️ The Record is exhaustive: a new cause is a COMPILE ERROR until it has words. Every sentence is plain and safe to show a
// club; none carries a name, a number or anything AF returned.

export const AF_HANDOVER_CAUSE_WORDS = {
  test_mode_refused: 'this calendar is in test mode and only books at the test club',
  no_club_info: "the club's name is missing from its business profile",
  club_mismatch: 'the lead enquired at a different club to this calendar',
  missing_details: "we are missing contact details Anytime Fitness needs to create the lead (such as an email address)",
  no_prospect: 'Anytime Fitness has no record of this lead to book against',
  cannot_book: "Anytime Fitness says this lead can't book online",
  af_unreadable: "we couldn't read the Anytime Fitness calendar just now",
  blocked: "Anytime Fitness's security blocked the booking",
  rejected: 'Anytime Fitness refused the booking',
  unrecognised: "Anytime Fitness gave an answer we couldn't read, so the booking may or may not have been made",
  timeout: "Anytime Fitness didn't answer in time, so the booking may or may not have been made",
  possible_earlier_landing: 'an earlier attempt may already have booked this time, so check ClubOS before booking again',
  details_declined: 'the lead would rather not give an email address, so no time was offered',
  internal_error: 'something went wrong on our side',
} as const;

export type AfHandoverCause = keyof typeof AF_HANDOVER_CAUSE_WORDS;
export const AF_HANDOVER_CAUSES = Object.keys(AF_HANDOVER_CAUSE_WORDS) as AfHandoverCause[];

export const BOOKING_FAILED_LEAD = "Booking didn't go through";

/** "Booking didn't go through: <cause in plain words>". An unknown (older) cause still says the booking didn't go through. */
export function bookingFailedLabel(cause: string | null | undefined): string {
  const words = cause && Object.prototype.hasOwnProperty.call(AF_HANDOVER_CAUSE_WORDS, cause) ? AF_HANDOVER_CAUSE_WORDS[cause as AfHandoverCause] : null;
  return words ? `${BOOKING_FAILED_LEAD}: ${words}` : BOOKING_FAILED_LEAD;
}
